import log from "loglevel";
import lodash from 'lodash';

// Set logging level based on the environment
if (process.env.NODE_ENV === "production") {
  log.setLevel("silent"); // Turn off all logging in production
} else {
  log.setLevel("debug"); // Enable debug logging in development
}

type StringCase = 'camel' | 'kebab' | 'lower' | 'snake' | 'start' | 'upper';

export function changeKeysCase<T = Record<string, unknown>>(
  data: Record<string, unknown>,
  toCase: StringCase = 'camel',
): T {
  const caseMapping: Record<StringCase, (string?: string) => string> = {
    camel: lodash.camelCase,
    kebab: lodash.kebabCase,
    lower: lodash.lowerCase,
    snake: lodash.snakeCase,
    start: lodash.startCase,
    upper: lodash.upperCase,
  };
  return lodash.mapKeys(data, (_: unknown, key: string | undefined) => caseMapping[toCase](key)) as T;
}


// export function useNormalizeBoolean(val: boolean | undefined | null): string {
//   if (val === null || val === undefined) {
//     return '';
//   }
//   return val ? 'Yes' : 'No';
// }
export function utilNormalizeCase(argument_0?: string | number) {
  if (lodash.isNumber(argument_0) || lodash.isString(argument_0)) {
    return lodash.startCase(lodash.lowerCase(String(argument_0)));
  }
}

export default log;
